import accountReducer from "@/redux/slices/accountSlice";
import formReducer from "@/redux/slices/formSlice";
import methodReducer from "@/redux/slices/methodSlice";
import transactionReducer from "@/redux/slices/transactionSlice";
import visibilityReducer from "@/redux/slices/visibilitySlice";
import { combineReducers, configureStore } from "@repo/redux-toolkit";

const combinedReducer = combineReducers({
  account: accountReducer,
  form: formReducer,
  visibility: visibilityReducer,
  method: methodReducer,
  transaction: transactionReducer,
});

export const makeStore = () => {
  return configureStore({ reducer: combinedReducer });
};

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<typeof combinedReducer>;
export type AppDispatch = AppStore["dispatch"];
